/**
 * Format a palm-report timestamp (epoch ms, from `reading.lastUpdated`) for the
 * result screen, in the two styles the design uses:
 * - "short" → "Feb 24, 2025"   (hero subtitle)
 * - "long"  → "February 24, 2025" (scan-based reading)
 * Returns "" for a missing/invalid timestamp so callers can omit the date.
 */
export function formatReportDate(ms: number | undefined, style: "short" | "long"): string {
  if (typeof ms !== "number" || !Number.isFinite(ms)) return ""
  const date = new Date(ms)
  if (Number.isNaN(date.getTime())) return ""
  return date.toLocaleDateString("en-US", { month: style, day: "numeric", year: "numeric" })
}
